import { Component, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BENEFICIO_SELECCIONADO_REFORMAS, DESCRIPCION_DETALLES_REFORMA_PENSIONES, DescripcionReforma, FAQ_CARD_REFORMA_PENSIONES, ICardReformaPensiones, RIGHT_COLUMN_DATA_REFORMA, TiposTextosImportanteReformaPensiones, TITLE_FAQS } from '@constants/reforma-pensiones.constants';
import { ROUTING_REFORMA_PENSIONES } from '@constants/url.constant';
import { TiposBeneficiosReforma, TitulosBeneficiosReforma } from '@enums/tipos-beneficios-reforma.enum';
import { StorageService } from '@services/storage/storage.service';
import { IFaqItem } from '@shared/common/interfaces/faq-card.interface';
import { IRightColumnData } from '@shared/common/interfaces/right-column-data.interface';
import { FaqCardComponent } from '@shared/components/faq-card';

@Component({
  selector: 'app-detalle-beneficio',
  templateUrl: './detalle-beneficio.component.html',
  styleUrl: './detalle-beneficio.component.scss',
  standalone: false
})
export class DetalleBeneficioComponent {
  @ViewChild('faqCard') faqCardComponent!: FaqCardComponent;
  loadingHome: boolean = false;
  beneficioSeleccionado: ICardReformaPensiones;
  showComponent: boolean = true;
  showErrorScreen: boolean = false;
  rightColumnData: IRightColumnData[] = [];
  faqCardData: IFaqItem[] = [];
  titleFaq: string = TITLE_FAQS;
  titleDetalleBeneficio: string = '';
  descripcionDetalleBeneficio: DescripcionReforma[] = [];
  tipoBeneficio: string = '';
  requisitosAjuste: string[] = [];
  requisitos: string[] = [];
  tipoBeneficiosDetalle = TiposTextosImportanteReformaPensiones.PaginaDetalleBeneficiosReforma;
  esMobile = window.innerWidth <= 360;
  urlCapitalPlay?: string;

  @HostListener('window:resize')
  onWindowResize() {
    this.esMobile = window.innerWidth <= 360;
  }

  constructor(private readonly router: Router,
    private readonly storageService: StorageService,
  ) { }

  async ionViewWillEnter() {
    this.beneficioSeleccionado = await this.storageService.get(BENEFICIO_SELECCIONADO_REFORMAS);
    this.initializeComponent();

    this.loadingHome = true;
  }
  initializeComponent() {
    switch (this.beneficioSeleccionado.id) {
      case TiposBeneficiosReforma.PGU:
        this.faqCardData = FAQ_CARD_REFORMA_PENSIONES[0].questions[0].items;
        this.titleFaq = FAQ_CARD_REFORMA_PENSIONES[0].questions[0].title;
        this.titleDetalleBeneficio = TitulosBeneficiosReforma.PGU;
        this.descripcionDetalleBeneficio = DESCRIPCION_DETALLES_REFORMA_PENSIONES.PGU.map(item => ({
          ...item,
          // Si el tipo no es 'imagen', por defecto será 'text'.
          type: item.type === 'imagen' ? 'imagen' : 'text'
        }));
        this.tipoBeneficio = TiposBeneficiosReforma.PGU;
        this.rightColumnData = [RIGHT_COLUMN_DATA_REFORMA[0]];
        break;
      case TiposBeneficiosReforma.BAC:
        this.faqCardData = FAQ_CARD_REFORMA_PENSIONES[1].questions[0].items;
        this.titleFaq = FAQ_CARD_REFORMA_PENSIONES[1].questions[0].title;
        this.titleDetalleBeneficio = TitulosBeneficiosReforma.BAC;
        this.descripcionDetalleBeneficio = DESCRIPCION_DETALLES_REFORMA_PENSIONES.BAC.map(item => ({
          ...item,
          // Si el tipo no es 'imagen', por defecto será 'text'.
          type: item.type === 'imagen' ? 'imagen' : 'text'
        }));
        this.requisitos = JSON.parse(this.descripcionDetalleBeneficio[2].content!);
        this.urlCapitalPlay = this.descripcionDetalleBeneficio[3].content;
        this.tipoBeneficio = TiposBeneficiosReforma.BAC;
        this.rightColumnData = [RIGHT_COLUMN_DATA_REFORMA[1]];
        break;
      case TiposBeneficiosReforma.UF_RETIRO_PROGRAMADO:
        this.faqCardData = FAQ_CARD_REFORMA_PENSIONES[2].questions[0].items;
        this.titleFaq = FAQ_CARD_REFORMA_PENSIONES[2].questions[0].title;
        this.titleDetalleBeneficio = TitulosBeneficiosReforma.UF_RETIRO_PROGRAMADO;
        this.descripcionDetalleBeneficio = DESCRIPCION_DETALLES_REFORMA_PENSIONES.UF_RETIRO_PROGRAMADO.map(item => ({
          ...item,
          // Si el tipo no es 'imagen', por defecto será 'text'.
          type: item.type === 'imagen' ? 'imagen' : 'text'
        }));
        this.requisitosAjuste = JSON.parse(this.descripcionDetalleBeneficio[2].content!);
        this.tipoBeneficio = TiposBeneficiosReforma.UF_RETIRO_PROGRAMADO;
        this.rightColumnData = [RIGHT_COLUMN_DATA_REFORMA[2]];
        break;
      case TiposBeneficiosReforma.CEV:
        this.faqCardData = FAQ_CARD_REFORMA_PENSIONES[3].questions[0].items;
        this.titleFaq = FAQ_CARD_REFORMA_PENSIONES[3].questions[0].title;
        this.titleDetalleBeneficio = TitulosBeneficiosReforma.CEV;
        this.descripcionDetalleBeneficio = DESCRIPCION_DETALLES_REFORMA_PENSIONES.CEV.map(item => ({
          ...item,
          // Si el tipo no es 'imagen', por defecto será 'text'.
          type: item.type === 'imagen' ? 'imagen' : 'text'
        }));
        this.requisitos = JSON.parse(this.descripcionDetalleBeneficio[2].content!);
        this.urlCapitalPlay = this.descripcionDetalleBeneficio[3].content;
        this.tipoBeneficio = TiposBeneficiosReforma.CEV;
        this.rightColumnData = [RIGHT_COLUMN_DATA_REFORMA[3]];
        break;
      default:
        // Manejar caso por defecto si es necesario
        break;
    }
  }

  goBack() {
    this.router.navigate([ROUTING_REFORMA_PENSIONES.REFORMA_PENSIONES_BASE,
    ROUTING_REFORMA_PENSIONES.BENEFICIOS_REFORMA_PENSIONES
    ]);
  }

  idRightColumnEmit(event: string) {
    const regex = /faq-answer-(\d+)/;
    const match = regex.exec(event);
    const numero = match ? Number.parseInt(match[1], 10) : -1;
    if (numero !== -1) this.faqCardComponent.toggleFaq(numero);

    setTimeout(() => {
      const element = document.getElementById(event);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } else {
        console.warn('Elemento no encontrado:', event);
      }
    }
      , 100);
  }

  public isBenefificarioSeleccionado(item: string): boolean {
    return (this.beneficioSeleccionado.id === item);
  }

  getImagen(imagenDesktop?: string, imagenMobile?: string): string {
    if (this.esMobile && imagenMobile) {
      return imagenMobile;
    }
    return imagenDesktop ?? '';
  }

}
